import React from "react";
import { Campaign } from "../../services";
import { authService } from "../../services/auth";
import CampaignTableRow from "./CampaignTableRow";

interface CampaignTableProps {
  campaigns: Campaign[];
  onToggleStatus: (id: string) => void;
  onEdit: (campaign: Campaign) => void;
  onDelete: (campaign: Campaign) => void;
  onPageChange: (page: string) => void;
  onShowDeleteModal: (campaign: Campaign) => void;
}

const CampaignTable: React.FC<CampaignTableProps> = ({
  campaigns,
  onToggleStatus,
  onEdit,
  onDelete,
  onPageChange,
  onShowDeleteModal,
}) => {
  const isAdmin = authService.isAdmin();
  return (
    <div className="overflow-hidden">
      <div className="">
        <table className="w-full table-fixed divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider w-28">
                Chiến Dịch
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider w-8">
                Link
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider w-20">
                Sản Phẩm
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider w-24">
                Thời Gian
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider w-16">
                <div>Tỷ Lệ Đổi</div>
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider w-20">
                Số Lượng Quà
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider w-16">
                Trạng Thái
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 dark:text-white uppercase tracking-wider w-16">
                Thao Tác
              </th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
            {campaigns.map((campaign) => (
              <CampaignTableRow
                key={campaign._id}
                campaign={campaign}
                onToggleStatus={onToggleStatus}
                onEdit={onEdit}
                onDelete={onDelete}
                onPageChange={onPageChange}
                onShowDeleteModal={onShowDeleteModal}
                isAdmin={isAdmin}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CampaignTable;
